<template>
  <div></div>
</template>

<script>
export default {
  mounted() {
    this.$store.dispatch("general/push_activePage", {
      name: "Dashboard",
      slug: "dashboard"
    });
    this.$store.dispatch("general/push_pointer", "dashboard");
  }
};
</script>

<style lang="scss" scoped></style>
